const currencySymbols: Record<string, string> = {
  RUB: '₽',
  KZT: '₸',
  USD: '$',
  EUR: '€',
  GBP: '£',
  CNY: '¥',
  JPY: '¥',
  KRW: '₩',
  INR: '₹',
  TRY: '₺',
  UZS: 'UZS'
};

export const formattedPrice = (
  price: number,
  currency: string = 'RUB',
  lang: string = 'ru-RU'
) => {
  const formatter = new Intl.NumberFormat(lang, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  let formatted = formatter.format(price);

  // если вернулся код валюты вместо символа — заменим
  if (formatted.includes(currency)) {
    const symbol = currencySymbols[currency];
    if (symbol) {
      formatted = formatted.replace(currency, symbol);
    }
  }

  return formatted;
};
